import { fromJS } from 'immutable';
import * as types from './constants';
import * as constants from '../App/constants';

import initialState from '../../../initialState';

const { REQUEST, SUCCESS, FAILURE } = constants;

const capReducer = (state = fromJS(initialState.intouchCap), action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return state.set('loginStatus', REQUEST).set('loginError', null);
    case types.LOGIN_SUCCESS:
      return state
        .set('loginStatus', SUCCESS)
        .set('loginError', null)
        .set('token', action.res.token)
        .set('user', fromJS(action.res.user))
        .set('orgID', action.res.user.orgID);
    case types.LOGIN_FAILURE:
      return state.set('loginStatus', FAILURE).set(
        'loginError',
        fromJS({
          message: action.error.message,
          errorCode: action.error.response.status,
        }),
      );
    case types.LOGOUT_REQUEST:
      return state.set('logoutStatus', REQUEST);
    case types.LOGOUT_SUCCESS:
      return state.set('logoutStatus', SUCCESS);
    case types.LOGOUT_FAILURE:
      return state
        .set('logoutStatus', FAILURE)
        .set('logoutError', fromJS(action.error));
    case types.CLEAR_TOPBAR_MENU_DATA:
      return state.set('topbarMenuData', fromJS({}));
    case types.SWITCH_ORG_REQUEST:
      return state.set('changeOrg', REQUEST);
    case types.SWITCH_ORG_SUCCESS:
      return state.set('orgID', action.orgID).set('changeOrg', SUCCESS);
    case types.SWITCH_ORG_FAILURE:
      return state.set(
        'changeOrg',
        fromJS({ status: FAILURE, error: action.error }),
      );
    case types.GET_USER_DATA_REQUEST:
      return state.set('fetchingUserdata', REQUEST);
    case types.GET_USER_DATA_SUCCESS:
      return state
        .set('fetchingUserdata', SUCCESS)
        .set('user', fromJS(action.userData))
        .set('currentOrgDetails', fromJS(action.currentOrgDetails))
        .set('orgID', action.currentOrgId);
    case types.GET_USER_DATA_FAILURE:
      return state.set('fetchingUserdata', FAILURE);
    case types.LAST_SYNC_TIME_REQUEST:
      return state
        .set('getLastSyncTimeStatus', REQUEST)
        .set('lastSyncTime', '')
        .set('lastSyncTimeError', null);
    case types.LAST_SYNC_TIME_SUCCESS:
      return state
        .set('getLastSyncTimeStatus', SUCCESS)
        .set('lastSyncTime', action.result);
    case types.LAST_SYNC_TIME_FAILURE:
      return state
        .set('getLastSyncTimeStatus', FAILURE)
        .set('lastSyncTimeError', action.error);
    case types.GET_BEAMER_POSTS_EXPLORE_REQUEST:
      return state
        .set('getBeamerPostsExploreStatus', REQUEST)
        .set('getBeamerPostsExploreError', null);
    case types.GET_BEAMER_POSTS_EXPLORE_SUCCESS:
      return state
        .set('getBeamerPostsExploreStatus', SUCCESS)
        .set('beamerPostsExplore', fromJS(action.result));
    case types.GET_BEAMER_POSTS_EXPLORE_FAILURE:
      return state
        .set('getBeamerPostsExploreStatus', FAILURE)
        .set('getBeamerPostsExploreError', action.error);
    case types.GET_BEAMER_POSTS_NOTIFICATION_REQUEST:
      return state
        .set('getBeamerPostsNotificationStatus', REQUEST)
        .set('getBeamerPostsNotificationError', null);
    case types.GET_BEAMER_POSTS_NOTIFICATION_SUCCESS:
      return state
        .set('getBeamerPostsNotificationStatus', SUCCESS)
        .set('beamerPostsNotification', fromJS(action.result));
    case types.GET_BEAMER_POSTS_NOTIFICATION_FAILURE:
      return state
        .set('getBeamerPostsNotificationStatus', FAILURE)
        .set('getBeamerPostsNotificationError', action.error);
    default:
      return state;
  }
};

export default capReducer;
